export const STATUS_CODE = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  SERVER_ERROR: 500,
} as const;

export const TOKEN_EXPIRED_MESSAGE = 'tokenExpired';
